import { createApp } from 'vue';

import '@nedap/unrux/dist/unrux.css';
import '@nedap/unrux/scss/colors.scss';

import { EnvironmentIndicator, Footer } from '@nedap/unrux';

import 'styles/fonts/fonts.scss';

/**
 * Load translations early, at least before jQuery/DataTables is loaded
 *  Translations are now only added to the `session.js` pack to enable debugging in a docker container (that only loads the login form)
 */
import './translations.js';

import 'components/session/session.scss';
import 'components/roadsign/roadsign';

import InlineSvg from 'vue-inline-svg';
import hardenInDomTemplates from 'utils/hardenInDomTemplates';

const app = createApp({
  components: {
    EnvironmentIndicator,
    'x-footer': Footer,
  },
});

app.component('inline-svg', InlineSvg);

hardenInDomTemplates(app);

window.vueApp = app.mount('#app');
